// tooltip-directives

const TooltipDirective = function (Vue) {
  Vue.directive('tooltip', {
    unbind: function (el, binding, vnode, oldVnode) {
      let element = oldVnode.data.toolTip
      if (element) {
        element.remove()
      }
    },

    componentUpdated: function(el, binding, vnode, oldVnode) {
      if (binding.value.text) {
        vnode.data.toolTip = oldVnode.data.toolTip
        vnode.data.toolTip.innerHTML = '<span>' + binding.value.text + '</span>'
      }
    },

    inserted: function(el, binding, vnode) {
      if (!binding.value.text) {
        return
      }
      const div = document.createElement('div')
      vnode.data.toolTip = div
      document.body.appendChild(div)

      div.classList.add('tooltip');

      if (binding.value.position === 'top') {
        div.classList.add('tooltip--top')
      }

      if (binding.value.position === 'left') {
        div.classList.add('tooltip--left')
      }

      if (binding.value.position === 'right') {
        div.classList.add('tooltip--right')
      }

      if (binding.value.position === 'bottom') {
        div.classList.add('tooltip--bottom')
      }

      div.innerHTML = '<span>' + binding.value.text + '</span>';

      setTooltipPosition();

      getScrollParent(el).addEventListener('scroll', function() {
        setTooltipPosition()
      })

      el.addEventListener('mouseover', function() {
        setTooltipPosition();
        vnode.data.showTimeout = setTimeout(function () {
          div.classList.add('tooltip--visible')
        }, binding.value.showDelay)
      })

      el.addEventListener('mouseout', function() {
        if (vnode.data.showTimeout) {
          clearTimeout(vnode.data.showTimeout)
          vnode.data._div = null
        }
        vnode.data.hideTimeout = setTimeout(function () {
          div.classList.remove('tooltip--visible')
        }, binding.value.hideDelay)
      })

      function setTooltipPosition () {
        let bodyRect = document.body.getBoundingClientRect()
        let elmRect = vnode.elm.getBoundingClientRect()

        let right
        let top
        let left
        let bottom

        if (binding.value.position === 'top') {
          top = elmRect.top;
          right = bodyRect.width - elmRect.left - (elmRect.width / 2)
        }

        if (binding.value.position === 'left') {
          top = elmRect.top + (elmRect.height / 2)
          right = bodyRect.width - elmRect.left + 10
        }

        if(binding.value.position === 'right') {
          top = elmRect.top + (elmRect.height / 2)
          left = elmRect.right + 10
        }

        if (binding.value.position === 'bottom') {
          top = elmRect.top + (elmRect.height / 2)
          right = bodyRect.width - elmRect.left - (elmRect.width / 2)
        }

        if (right) {
          div.style.right = right + 'px'
        }

        if (left) {
          div.style.left = left + 'px'
        }

        if (top) {
          div.style.top = top + 'px'
        }

        if (bottom) {
          div.style.bottom = top + 'px'
        }
      }

      /*
      * The following methods were taken from: https://github.com/Akryum/v-tooltip
      */

      function getStyleComputedProperty(element, property) {
        if (element.nodeType !== 1) {
          return [];
        }
        // NOTE: 1 DOM access here
        let window = element.ownerDocument.defaultView;
        let css = window.getComputedStyle(element, null);
        return property ? css[property] : css;
      }

      function getParentNode(element) {
        if (element.nodeName === 'HTML') {
          return element;
        }
        return element.parentNode || element.host;
      }

      function getScrollParent(element) {
        // Return body, `getScroll` will take care to get the correct `scrollTop` from it
        if (!element) {
          return document.body;
        }

        switch (element.nodeName) {
          case 'HTML':
          case 'BODY':
            return element.ownerDocument.body;
          case '#document':
            return element.body;
        }

        // Firefox want us to check `-x` and `-y` variations as well

        let _getStyleComputedProp = getStyleComputedProperty(element);
        let overflow = _getStyleComputedProp.overflow;
        let overflowX = _getStyleComputedProp.overflowX;
        let overflowY = _getStyleComputedProp.overflowY;

        if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
          return element;
        }

        return getScrollParent(getParentNode(element));
      }
    }
  });
};

export default TooltipDirective



//////////////////
// WEBPACK FOOTER
// ./node_modules/pro4all-ui/plugins/directives/tooltip-directive.js
// module id = null
// module chunks = 